import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { Tooltip } from 'antd'
import styles from './patternElement.module.less'

interface PatternElement {
  designTypeList: string[]
  patternTypeList: string[]
  patternColorEntityList: Array<{ name: string; color: string; enName: string; colorNumber: string }>
}

export default function PatternElement({ patternAbroadDTO }: { patternAbroadDTO: PatternElement }) {
  if (
    patternAbroadDTO?.designTypeList?.length === 0 &&
    patternAbroadDTO?.patternTypeList?.length === 0 &&
    patternAbroadDTO?.patternColorEntityList?.length === 0
  ) {
    return
  }
  return (
    <div className={classNames(styles.infoBlock, 'mt32')}>
      <div className={styles.titleLine}>
        <div className={styles.point} />
        <div className={styles.mainTitle}>
          智能标签
          <Tooltip placement="bottom" style={{ color: '#fff', width: '160px' }} title="基于知衣独家图像识别模型生成服饰类标签">
            <Icon type="m-bangzhu_miaobian" style={{ color: 'var(--m-text-3)', marginLeft: '8px' }} />
          </Tooltip>
        </div>
      </div>
      <div className={styles.infoBlockContext}>
        <div className={styles.patternElement}>
          <ul>
            {!!patternAbroadDTO?.patternTypeList?.length && (
              <li className={styles.elementItem} style={{ justifyContent: 'normal' }}>
                <span className={styles.itemKey}>图案类型</span>
                <span className={styles.itemValueWrapper}>
                  {patternAbroadDTO?.patternTypeList?.map((m) =>
                    m.split(',').map((n) => <span className={styles.itemValue}>{n}</span>)
                  )}
                </span>
              </li>
            )}

            {!!patternAbroadDTO?.designTypeList?.length && (
              <li className={styles.elementItem} style={{ justifyContent: 'normal' }}>
                <span className={styles.itemKey}>定位满印</span>
                <span className={styles.itemValueWrapper}>
                  {patternAbroadDTO?.designTypeList?.map((m) =>
                    m.split(',').map((n) => <span className={styles.itemValue}>{n}</span>)
                  )}
                </span>
              </li>
            )}

            {patternAbroadDTO?.patternColorEntityList && patternAbroadDTO?.patternColorEntityList.length ? (
              <li className={styles.elementItem}>
                <span className={styles.itemKey}>颜色</span>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse' }}>
                  {patternAbroadDTO?.patternColorEntityList?.slice(0, 5).map((value) => (
                    <Tooltip
                      placement="topRight"
                      arrowPointAtCenter
                      title={
                        <div style={{ position: 'relative' }}>
                          <span
                            style={{
                              position: 'absolute',
                              height: 2,
                              left: -6,
                              right: -6,
                              top: -6,
                              backgroundColor: value.color,
                            }}
                          />
                          <span>{value.name}</span>
                          <span>{value.enName}</span>
                          <span>{value.colorNumber}</span>
                          <span>{value.color}</span>
                        </div>
                      }
                    >
                      <div key={value.color} className={styles.itemValueColor} style={{ backgroundColor: value.color }} />
                    </Tooltip>
                  ))}
                </div>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  )
}
